import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";
import DateTimeHelper from "../helper/date-time-helper";
import moment from "moment";

const addTrainingLink = (fields) => {
    const trainingDate = DateTimeHelper.concatDateTimeOfTwoDates(
      fields.trainingDate,
      fields.trainingTime
    );
    const expirationDate = DateTimeHelper.concatDateTimeOfTwoDates(
      fields.expirationDate,
      fields.expirationTime
    );
    const data = {
      url: fields?.url,
      title: fields?.title,
      description:fields?.description,
      textOnLink: fields?.textOnLink,
      trainingDate:moment(trainingDate).format('YYYY-MM-DD HH:mm:ss'),
      expirationDate:moment(expirationDate).format('YYYY-MM-DD HH:mm:ss'),
    };
    return ApiHelper.postRequest(API_URLS.INSERT_TRAINING_LINK, data);
  };
  const getAllTrainingLinks = (params) => {
    return ApiHelper.getRequest(`${API_URLS.GET_TRAINING_LINKS}?startDate=${params?.startDate}&endDate=${params?.endDate}`);
  };
  const deleteTrainingLink = (trainingLinkId) => {
    return ApiHelper.postRequest(API_URLS.DELETE_TRAINING_LINK + trainingLinkId);
  };
  const updateTrainingLink = (fields, state) => {
    const trainingDate = DateTimeHelper.concatDateTimeOfTwoDates(
      fields.trainingDate,
      fields.trainingTime
    );
    const expirationDate = DateTimeHelper.concatDateTimeOfTwoDates(
      fields.expirationDate,
      fields.expirationTime
    );
    const data = {
      id:state.id,
      isActive:state.isActive,
      url: fields?.url,
      title: fields?.title,
      description:fields?.description,
      trainingDate:moment(trainingDate).format('YYYY-MM-DD HH:mm:ss'),
      expirationDate:moment(expirationDate).format('YYYY-MM-DD HH:mm:ss'),
      textOnLink: fields?.textOnLink,
    };
    return ApiHelper.postRequest(API_URLS.UPDATE_TRAINING_LINK, data);
  };
  
  export const TrainingServices = {
    addTrainingLink,
    getAllTrainingLinks,
    deleteTrainingLink,
    updateTrainingLink
  };